<div [formGroup]="formGroup" class="pure-g">
  <!-- Active -->
  <div class="pure-u-1 pure-u-md-6-24 p-r-16 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="isActive"
        [checked]="formGroup.get('isActive')?.value || false"
        (change)="onSwitchChange($event, 'isActive')"
        label="Active"
        name="isActive"
        fit="small">
      </mc-switch>
    </div>
  </div>

  <!-- Deduct Core Value -->
  <div class="pure-u-1 pure-u-md-6-24 p-r-16 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="deductCore"
        [checked]="formGroup.get('deductCore')?.value || false"
        (change)="onSwitchChange($event, 'deductCore')"
        label="Deduct Core Value"
        name="deductCore"
        fit="small">
      </mc-switch>
    </div>
  </div>

  <!-- Serial Tag Number Required -->
  <div class="pure-u-1 pure-u-md-6-24 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="isSerialTagNumberRequired"
        [checked]="formGroup.get('isSerialTagNumberRequired')?.value || false"
        (change)="onSwitchChange($event, 'isSerialTagNumberRequired')"
        label="Serial Tag Number Required"
        name="isSerialTagNumberRequired"
        fit="small">
      </mc-switch>
    </div>
  </div>
</div>
